import React from 'react';
import { useNavigate } from 'react-router-dom';
export function BetIQAccessPage() {
  const navigate = useNavigate();
  return <main className="min-h-screen w-full bg-brand-bg text-brand-text flex flex-col items-center justify-center p-4" data-id="element-314">
      <h1 className="text-3xl font-bold text-brand-gold mb-4" data-id="element-315">
        Página en construcción
      </h1>
      <p className="text-brand-muted mb-8" data-id="element-316">Acceso a BetIQ</p>
      <button onClick={() => navigate('/')} className="text-brand-gold underline" data-id="element-317">
        Volver al inicio
      </button>
    </main>;
}